import axios from 'axios';
import { config } from './utils';

export const removeUploadAssets = async (
  token: string,
  id?: string,
  organizationId?: string
) => {
  if (organizationId) {
    const result = await axios.delete(
      `${config.BASE_URL}/upload-asset/${id}?organizationId=${organizationId}`,
      {
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    if (result?.status === 200) {
      return true;
    } else {
      return false;
    }
  } else {
    const result = await axios.delete(`${config.BASE_URL}/upload-asset/${id}`, {
      headers: {
        Authorization: `${token}`,
      },
    });
    if (result?.status === 200) {
      return true;
    } else {
      return false;
    }
  }
};
